module.exports = __webpack_public_path__ + "images/plush.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/plush.png
// module id = 98ja
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13